import ApiService from './ApiService.js'

export default {
  get (id, params = {}) {
    return ApiService.get('licence-reports', id, params)
  },

  /** all contracts, crops having .licensor,.licencee,.year */
  getContractSubjects (params = {}) {
    return ApiService.get('licence-reports', 'contract-subjects', params)
  },

  /** at most 1 contract subject for .licensor,.licencee,.year, */
  findMatchingContractSubjectForEntry (params = {}) {
    return ApiService.get('licence-reports', 'contract-subject', params)
  },

  findAvaliableCountriesForEntry (params = {}) {
    return ApiService.get('licence-reports', 'avaliable-countries', params)
  },

  pdf (id, locale = 'de', params) {
    return ApiService.get('licence-reports', `${id}/pdf/${locale}`, params)
  },

  find (params, subresource = '') {
    return ApiService.get('licence-reports', subresource, params)
  },

  put (payload, slug = []) {
    return ApiService.put('licence-reports', slug, { payload })
  },

  post (payload) {
    return ApiService.post('licence-reports', { payload })
  },

  finalize (id) {
    return ApiService.put(`licence-reports/${id}/finalize`)
  },

  correct (id) {
    return ApiService.put(`licence-reports/${id}/correction`)
  },

  trash (id) {
    return ApiService.trash('licence-reports', id)
  },

  untrash (id) {
    return ApiService.untrash('licence-reports', id)
  },

  delete (id) {
    return ApiService.delete('licence-reports', id)
  }
}
